import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Publish } from "../requirement/Publish";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { Interview_Process } from "../../models/RequirementMast";


interface IProps {
    singleData: any,
    open: boolean | undefined,
    hideDialog: () => void,
    toast: any,
}

export const SubTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [heading, setHeading] = useState<string>('');
    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });

    const dt = useRef<any>();

    const loadData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("PrimeVendorPerformanceReports/pvprSubList", "GET", null, `type=${props.singleData.type}&filter=${JSON.stringify(props.singleData.filter)}&vendor_Company_ID=${props.singleData.singleData.vendor_Company_ID}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center flex justify-content-between bg-white">
            <h5 className="m-0">{heading}</h5>
            {/* <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} /> */}
        </div>
    );

    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    useEffect(() => {
        if (props.open) loadData();
        if (props.singleData.type === "Req") setHeading("Requirement Wise PV Performance Report");
        if (props.singleData.type === "Sub") setHeading("Prime Vendor Submission Report");
        if (props.singleData.type === "SubClient") setHeading("Prime Vendor Submission Report");
        if (props.singleData.type === "ECI") setHeading("Prime Vendor Submission Report");
        if (props.singleData.type === "PO") setHeading("Prime Vendor Submission Report");
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="" modal className="p-fluid" onHide={onHide}>
            {props.open && props.singleData.type === "Req" && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines columnResizeMode="expand" scrollable scrollHeight="65vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} />
                <Column field="req_ID" header="Req ID" sortable />
                <Column field="req_Job_Title" header="Job Title" sortable body={req_Job_Title} />
                <Column field="req_Duration" header="Duration" />
                <Column field="req_Rate" header="Rate" />
                <Column field="req_InterviewProcess" header="Int Mode" body={(rowData: any) => rowData.req_InterviewProcess ? Interview_Process[rowData.req_InterviewProcess] : ""} />
                <Column field="resume" header="Resume" />
                <Column field="eci" header="ECI" />
                <Column field="po" header="PO" />
                <Column field="status" header="Status" />
            </DataTable>
            }
            {props.open && props.singleData.type != "Req" && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="65vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} />
                <Column field="consultant_Name" header="Consultant_Name" />
                <Column field="sales" header="Sales" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="req_Job_Title" header="Req_Job_Title" body={req_Job_Title} />
                <Column field="end_Client" header="End_Client" />
                <Column field="prime_Vendor" header="Prime_Vendor" />
                <Column field="sub_Vendor" header="Sub_Vendor" />
                {/* <Column field="sub_Date" header="Sub_Date" /> */}
                <Column field="sub_Date" header="Sub_Date" body={(rowData: any) => safeFormatDate(rowData.sub_Date, 'dd-MM-yyyy', DateFormat)} />
                <Column field="sub_Time" header="Sub_Time" />
                <Column field="status" header="Status" />
                <Column field="comment" header="Comment" body={(e) => (e.comment === null || e.comment === '') ? <p>No Comment</p> : <p>{e.comment}</p>} />
            </DataTable>

            }
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
        </Dialog>

    );
}